export default __webpack_public_path__ + "static/media/Anita_Ghazi_Rahman_AHV_In_Moms_We_Trust.cda11697.jpg";